window.image = {
    $images: null,

    init: function ($images) {
        this.$images = $images;
        this.initLightboxListeners();
    },

    /**
     * Initialize all Images to activate the Lightbox Listener on click
     */
    initLightboxListeners() {
        this.$images.forEach(function (item){
            var $imageBox = item.querySelector(".lightbox__image"),
                $image = $imageBox.querySelector("img");

            $image.addEventListener('click', function (){
                var $template = window.image.createLightboxTemplate(this.getAttribute('src')),
                    $body = document.body;

                $body.insertAdjacentElement("beforeend", $template);

                setTimeout(function (){
                    $body.className += "overflow--hidden";
                    document.querySelector(".lightbox__popup").className += " lightbox__popup--active";

                    window.image.closeLightboxListeners();
                },300);
            });
        });
    },

    /**
     * create Lightbox Template based on clicked Element
     * @param $imgSource
     * @returns {string}
     */
    createLightboxTemplate: function ($imgSource) {
        var $template = document.createElement("div"),
            $elementHTML = '' +
            '<div class="lightbox__popup lightbox__popup--blue">' +
            '   <span class="lightbox__popup--close icon-close"></span>' +
            '   <div class="lightbox__popup--image">' +
            '       <img src="{imgSource}" />' +
            '   </div>' +
            '</div>';

        $elementHTML = $elementHTML.replace('{imgSource}', $imgSource);
        $template.classList.add("lightbox__remove");
        $template.innerHTML = $elementHTML;

        return $template;
    },

    /**
     * Close Lightbox Event Listeners
     */
    closeLightboxListeners: function () {
        var $closeIcon = document.querySelector(".lightbox__popup--close"),
            $body = document.body,
            $lightbox = document.querySelector(".lightbox__remove");

        $closeIcon.addEventListener('click', function (){
            window.image.closeLightbox($body, $lightbox);
        });

        document.onkeydown = function(evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                window.image.closeLightbox($body, $lightbox);
            }
        };
    },

    /**
     * Close active Lightbox
     */
    closeLightbox: function ($body, $lightbox) {
        $lightbox.querySelector(".lightbox__popup").classList.remove("lightbox__popup--active");

        setTimeout(function (){
            $body.classList.remove("overflow--hidden");
            $lightbox.remove();
        },500);
    }
}
